/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Modal from 'bootstrap/js/dist/modal';

/*------------------------------------*\
    SHARE
\*------------------------------------*/
class Share {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.shareButton = self.elem.querySelector('[data-share-button]');
        self.modal = new Modal(self.elem.querySelector('[data-share-modal]'));
    }

    init() {
        let self = this;

        self.shareButton.addEventListener('click', event => {
            if (navigator.share) {
                navigator.share({
                    title: document.title,
                    url: document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href
                }).then(() => {
                    // success
                }).catch(console.error);
            } else {
                // fallback
                self.modal.show();
            }
        });
    }
}

export default Share;
